import { useQuery } from '@apollo/client';

import { GetToolboxOfferDocument } from './getToolboxOffer.gql';

const useGetToolboxOffer = (id: string) => {
  const { data, ...hook } = useQuery(GetToolboxOfferDocument, {
    variables: { toolboxOfferId: id },
  });

  const offer = data?.toolboxOffer;

  return {
    ...hook,
    offer,
  };
};

export type ToolboxOffer = NonNullable<
  ReturnType<typeof useGetToolboxOffer>['offer']
>;

export default useGetToolboxOffer;
